module.exports = __webpack_public_path__ + "static/media/MM_Logo.567bf3a2.png";